export const lastOne = (...args: any[]) => {
  return args.reverse().find((arg) => {
    return typeof arg !== 'undefined'
  })
}
